(function () {
  'use strict';

  /* @ngdoc object
   * @name chat
   * @description
   *
   */
  angular
    .module('vcchat', [
      'ui.router',
      'knalli.angular-vertxbus',
      'luegg.directives'
    ]);
}());